import { type LessonForDashboard, type StreamForDashboard } from 'Lessons';
import { type LessonProgress, type StreamProgress } from './ContentProgress.types';

type HasCompletedTestArgs = {
    lesson?: LessonForDashboard;
    lessonProgress?: LessonProgress | null;
    stream?: StreamForDashboard | null;
    streamProgress?: StreamProgress | null;
};

export function hasCompletedTest({ lesson, lessonProgress, stream, streamProgress }: HasCompletedTestArgs): boolean {
    const lessonIsTest = lesson?.test ?? false;
    const lessonIsComplete = lessonProgress?.complete ?? false;
    if (lessonIsTest && lessonIsComplete) return true;

    // this is an edge case, but if a user's progress has been
    // transferred from one exam to another, they might have the
    // exam marked as complete when they have not completed all of the
    // lessons in the exam.  If that's the case, we want to show the lessons
    // as being complete
    const streamIsExam = stream?.exam ?? false;
    const streamIsComplete = streamProgress?.complete ?? false;
    if (streamIsExam && streamIsComplete) return true;

    return false;
}
